import TenantOverviewView from './views/TenantOverviewView.vue'

export default [
  { path: '/tenant/overview', name: 'tenant/overview', navHide: true, component: TenantOverviewView, meta: { title: 'Tenant Overview', layout: 'narrow' } },
]



// WEBPACK FOOTER //
// ./src/tenant/routes.js